import { useTranslation } from 'react-i18next';

interface FieldStatusProps {
  fieldName: string;
  isComplete: boolean;
  packagingLayer?: string;
}

export function FieldStatus({ fieldName, isComplete, packagingLayer }: FieldStatusProps) {
  const { t } = useTranslation();

  return (
    <div
      data-testid={`field-status-${fieldName.toLowerCase().replace(/\s+/g, '-')}`}
      data-field-status={isComplete ? 'complete' : 'missing'}
      className="flex items-center justify-between py-2 px-1"
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        {isComplete ? (
          <span
            data-testid="field-status-icon"
            className="material-symbols-outlined shrink-0"
            style={{ fontSize: '18px', color: 'var(--success-dark)' }}
            aria-hidden="true"
          >
            check_circle
          </span>
        ) : (
          <span
            data-testid="field-status-icon"
            className="material-symbols-outlined shrink-0"
            style={{ fontSize: '18px', color: 'var(--destructive)' }}
            aria-hidden="true"
          >
            cancel
          </span>
        )}
        <span
          className="text-[0.8125rem]"
          style={{ color: isComplete ? 'var(--foreground)' : 'var(--foreground-muted)' }}
        >
          {fieldName}
          {packagingLayer && (
            <span style={{ color: 'var(--foreground-muted)' }}> ({packagingLayer})</span>
          )}
        </span>
        {!isComplete && (
          <span
            className="text-xs shrink-0"
            style={{ color: 'var(--destructive)' }}
          >
            {t('products.detail.missing')}
          </span>
        )}
      </div>
      {/* Action slot for future upload buttons (fase 2b) */}
      <div className="field-status-action" />
    </div>
  );
}
